import axios from "axios";

import { config } from "./config";
import { fixedValues } from "./fixedValues";
import {
  clearLocalStorage,
  getLocalStorageItem,
  LOCAL_STORAGE_KEYS,
} from "./localStorage";
import { AUTH_STACK } from "./screenNames";

export const authApi = axios.create({
  baseURL: `${config.API_BASE_URL}/${config.API_PATH}/`,
  headers: {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "true",
  },
});

authApi.interceptors.request.use((config) => {
  const accessString = window.localStorage.getItem("access");
  if (accessString) {
    const access = JSON.parse(accessString);
    config.headers.Authorization = `Bearer ${access.token}`;
  }
  return config;
});

authApi.interceptors.response.use(
  (response) => response,
  (error) => {
    // Skip redirect for public tournament routes
    const isPublicRoute = window.location.pathname.includes("/public/");
    // Skip redirect for auth endpoints (e.g. wrong password on login)
    const isAuthEndpoint = error.config?.url?.startsWith("/auth/");
    if (
      error.response?.status === fixedValues.responseCodes.UNAUTHORIZED &&
      !isPublicRoute &&
      !isAuthEndpoint
    ) {
      // Clear localStorage
      clearLocalStorage();
      // Redirect to login
      window.location.href = AUTH_STACK.LOGIN_OPTIONS;
    }
    return Promise.reject(error);
  }
);

export const noAuthApi = axios.create({
  baseURL: config.API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

noAuthApi.interceptors.response.use(
  (response) => response,
  (error) => {
    // Skip redirect for public tournament routes
    const isPublicRoute = window.location.pathname.includes("/public/");
    if (
      error.response?.status === fixedValues.responseCodes.UNAUTHORIZED &&
      !isPublicRoute
    ) {
      // Clear localStorage
      clearLocalStorage();
      // Redirect to login
      window.location.href = AUTH_STACK.LOGIN_OPTIONS;
    }
    return Promise.reject(error);
  }
);

export default authApi;
